<template>
  <section v-if="isHomeRoute" class="shell-section fomo-liquid-shell">
    <section id="fomo-qr-slide" ref="hero" aria-label="Vive tu próximo evento con FOMO">
      <div class="fq-art">
        <div class="fq-sculpture">
          <div class="fq-fallback" aria-hidden="true">
            <canvas width="232" height="232" data-qr-fallback></canvas>
          </div>
          <canvas
            class="fq-canvas"
            width="520"
            height="420"
            role="img"
            aria-label="Un QR se transforma en una escultura líquida plata y violeta que gira y acompaña el recorrido por la página."
          ></canvas
          ><canvas class="fq-canvas fq-pixels" width="520" height="420" aria-hidden="true"></canvas>
        </div>
      </div>
      <div class="fq-copy">
        <div class="fq-kicker">LA VIDA, EN PRIMERA PERSONA.</div>
        <h1 class="fq-title">
          <span class="fq-title-line">Planes en los</span>
          <span class="fq-title-line">que tienes</span>
          <span class="fq-title-line fq-title-accent">que estar.</span>
        </h1>
        <p class="fq-subtitle">Menos «algún día».<br />Más «qué bueno que fuimos».</p>
        <div class="fq-actions">
          <div class="fq-action">
            <FomoButton variant="primary" class="cursor-interaction" @click="scrollToEvents"
              >Explorar eventos</FomoButton
            >
          </div>
          <div class="fq-action">
            <FomoButton icon="fas fa-calendar-alt" class="cursor-interaction" @click="openWss"
              >Vende con FOMO</FomoButton
            >
          </div>
        </div>
      </div>
      <div class="fq-controls" aria-label="Movimiento de la forma">
        <button class="cursor-interaction" type="button" data-replay>
          <span class="fq-control-symbol" aria-hidden="true">↺</span>Repetir QR</button
        ><button class="cursor-interaction" type="button" data-pause aria-pressed="false">
          <span class="fq-control-symbol" data-pause-symbol aria-hidden="true">Ⅱ</span
          ><span data-pause-text>Pausar</span>
        </button>
      </div>
      <div class="fq-status" role="status" aria-live="polite" data-status></div>
    </section>
  </section>
</template>
<script>
import FomoButton from '@/components/ui/FomoButton.vue'
import { createFomoLiquidHero } from './home/createFomoLiquidHero'
import { createFomoHomeIntro } from './home/createFomoHomeIntro'
import './home/fomo-liquid-hero.css'
export default {
  name: 'SlideShow',
  components: { FomoButton },
  props: {
    main: { default: null },
    subtitle: { default: null },
    type: { default: 2 },
    activeEventsCount: { type: Number, default: null },
  },
  computed: {
    isHomeRoute() {
      return this.$route && this.$route.name === 'home'
    },
  },
  watch: {
    isHomeRoute() {
      this.stopExperience()
      this.$nextTick(this.startExperience)
    },
  },
  mounted() {
    this.startExperience()
  },
  beforeUnmount() {
    this.stopExperience()
  },
  methods: {
    startExperience() {
      if (!this.isHomeRoute || !this.$refs.hero || this.disposeIntro) return
      this.disposeIntro = createFomoHomeIntro(() => this.startAnimation())
    },
    stopExperience() {
      this.disposeIntro?.()
      this.disposeIntro = null
      this.stopAnimation()
    },
    startAnimation() {
      if (this.$refs.hero && !this.disposeAnimation)
        this.disposeAnimation = createFomoLiquidHero(this.$refs.hero)
    },
    stopAnimation() {
      this.disposeAnimation?.()
      this.disposeAnimation = null
    },
    scrollToEvents() {
      const section = document.getElementById('agenda-activa')
      if (section)
        section.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        })
    },
    openWss() {
      this.$router.push({ name: 'sell-with-fomo' })
    },
  },
}
</script>
